exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../node_modules/postcss-loader/lib/index.js??postcss!../styleColors.css"), undefined);

// module
exports.push([module.id, ".Copyright_copyright_2hunT {\n  text-align: center;\n  color: #fff;\n  padding-top: 1rem;\n  font-size: 0.7rem;\n}\n\n/* Small Devices, Tablets */\n@media only screen and (min-width: 768px) {\n  .Copyright_copyright_2hunT {\n    margin: 0;\n    padding-top: 0;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 100%;\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n    text-align: right;\n  }\n}\n\n/* Large Devices, Wide Screens */\n@media only screen and (min-width: 1167px) {\n  .Copyright_copyright_2hunT {\n    margin: 0;\n    padding-top: 0;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"dkGrey": "" + require("-!../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../node_modules/postcss-loader/lib/index.js??postcss!../styleColors.css").locals["dkGrey"] + "",
	"copyright": "Copyright_copyright_2hunT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Copyright.css
// module id = 1072
// module chunks = 0